import { CoasterDocument, fileToDocument } from '../core/doc/document';

/** Filename (no extension) used when nothing is in localStorage yet. */
export const DEFAULT_RIDE_ID = 'platform-15.rcsim';

export interface DefaultRide {
  id: string;
  name: string;
  blurb: string;
  build: () => CoasterDocument;
}

const rawModules = import.meta.glob('../../DefaultRides/*.json', {
  eager: true,
  import: 'default',
}) as Record<string, unknown>;

function idFromPath(path: string): string {
  const file = path.split('/').pop() ?? path;
  return file.replace(/\.json$/i, '');
}

/** Prefer the DefaultRides filename so the list matches the folder. */
function displayName(id: string): string {
  return id.replace(/-/g, ' ');
}

export const defaultRides: DefaultRide[] = Object.entries(rawModules)
  .map(([path, data]) => {
    const id = idFromPath(path);
    return {
      id,
      name: displayName(id),
      blurb: `DefaultRides/${id}.json`,
      build: () => fileToDocument(data),
    };
  })
  .sort((a, b) => a.name.localeCompare(b.name));

export function getDefaultRide(): CoasterDocument {
  const ride = defaultRides.find((r) => r.id === DEFAULT_RIDE_ID) ?? defaultRides[0];
  if (!ride) throw new Error('No DefaultRides presets found');
  return ride.build();
}
